import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'

import { CHART_ANIMATION_PIE, CHART_LEGEND_STYLE, CHART_TOOLTIP_STYLE } from './chartTheme'

export const PieChartComponent = ({
  data,
  colors,
  innerRadius,
  outerRadius,
  paddingAngle,
  legend,
  dataKey,
  onCellClick,
  tooltipProps,
  legendProps
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart style={{ cursor: 'pointer' }}>
        <Tooltip contentStyle={CHART_TOOLTIP_STYLE} {...tooltipProps} />
        {legend ? (
          <Legend
            iconType="circle"
            iconSize={8}
            wrapperStyle={CHART_LEGEND_STYLE}
            {...legendProps}
          />
        ) : null}
        <Pie
          dataKey={dataKey}
          data={data}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          paddingAngle={paddingAngle}
          animationDuration={CHART_ANIMATION_PIE.duration}
          animationEasing={CHART_ANIMATION_PIE.easing}
          stroke="none"
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={colors[index % colors.length]}
              onClick={() => onCellClick && onCellClick(entry.name)}
              style={{ filter: 'saturate(0.9)', transition: 'filter 0.2s' }}
            />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  )
}
